import { Link } from 'react-router-dom';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-ruler-line',
      title: '0.01mm単位の超精密加工',
      description: '最新のCNC旋盤と熟練職人の技術で、ミクロン単位の精度を実現。岡山市の製造業で培った50年の経験により、規格品では対応できない特殊な形状のネジ加工も可能です。',
    },
    {
      icon: 'ri-time-line',
      title: '短納期対応',
      description: '試作1本からの小ロット対応が可能。お急ぎの案件も柔軟に対応いたします。岡山市近隣の設計担当者様からの緊急依頼にも迅速にお応えします。',
    },
    {
      icon: 'ri-tools-line',
      title: '難削材加工の実績',
      description: 'チタン、ステンレス、インコネルなど難削材の加工経験が豊富。岡山市の町工場として、新製品の試作開発に必要な特殊材料の加工技術を持っています。',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Left Side - Heading */}
          <div className="lg:col-span-5">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-navy mb-4 sm:mb-6 leading-tight tracking-tight">
              おかやまネジ製作所が<br />選ばれる理由
            </h2>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
              創業50年の技術と経験で、規格品では対応できない特殊なニーズにお応えします。岡山市を中心とした製造業の設計担当者様の課題を解決します。
            </p>
          </div>

          {/* Right Side - Feature Cards */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white border border-navy rounded-xl p-6 sm:p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-full mb-4 sm:mb-6">
                    <i className={`${feature.icon} text-3xl sm:text-4xl text-navy`}></i>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-navy mb-3 sm:mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mt-10 sm:mt-12">
          <Link
            to="/business"
            className="inline-block bg-navy text-white text-base font-bold px-10 py-4 rounded-md hover:opacity-80 transition-opacity duration-200 whitespace-nowrap cursor-pointer"
          >
            詳しく見る
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;